import { lazy } from "react";

const Main = lazy(() => import("@src/pages/balanceGame/Main"));
const Game = lazy(() => import("@src/pages/balanceGame/Game"));
const Loading = lazy(() => import("@src/pages/balanceGame/Loading"));
const Result = lazy(() => import("@src/pages/balanceGame/Result"));
const TotalResult = lazy(() => import("@src/pages/balanceGame/TotalResult"));
const TotalResultGuest = lazy(() => import("@src/pages/balanceGame/guest/TotalResultGuest"));

export const balanceGameRoutes = [
  { path: "/balance-game", element: <Main /> },
  { path: "/balance-game/game", element: <Game /> },
  { path: "/balance-game/loading", element: <Loading /> },
  { path: "/balance-game/result", element: <Result /> },
  { path: "/balance-game/total-result", element: <TotalResult /> },
  { path: "/balance-game/total-result/guest", element: <TotalResultGuest /> },
];
